import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SponsorshipsService } from 'src/app/shared/services/sponsorships.service';
import { SponsorshipRequestService } from 'src/app/shared/services/sponsorship-request.service';

@Component({
  selector: 'app-view-single-sponsorship-requests',
  templateUrl: './view-single-sponsorship-request.component.html',
  styleUrls: ['./view-single-sponsorship-request.component.css']
})
export class ViewSingleSponsorshipRequestComponent implements OnInit {

  editSponsorshipForm: FormGroup;
  isLoading: boolean = false;
  sponsorships: any = [];
  constructor(private router: Router, private fb: FormBuilder, private route: ActivatedRoute, private sponsorshipsService: SponsorshipsService, private sponsorshipRequestService: SponsorshipRequestService) {
    this.editSponsorshipForm = this.fb.group({
      name: [''],
      value: [''],
      status: [''],
      type: [''],
      sponsorName: [''],
      propertyName: [''],
      startDate: [''],
      endDate: ['']
    });
  }

  recievedSponsorship: any;

  customStylesValidated = false;

  ngOnInit(): void {
    console.log("router: ", this.router);
    this.route.queryParams.subscribe(params => {

      this.recievedSponsorship = params;
      console.log("recievedSponsorship: ", this.recievedSponsorship);
    }
    );

    const formValues = {
      name: [this.recievedSponsorship.name ? this.recievedSponsorship.name : ''],
      value: [this.recievedSponsorship.value ? this.recievedSponsorship.value : ''],
      status: [this.recievedSponsorship.status ? this.recievedSponsorship.status : ''],
      type: [this.recievedSponsorship.type ? this.recievedSponsorship.type : ''],
      sponsorName: [this.recievedSponsorship.sponsorName ? this.recievedSponsorship.sponsorName : ''],
      propertyName: [this.recievedSponsorship.propertyName ? this.recievedSponsorship.propertyName : ''],
      startDate: [this.recievedSponsorship.startDate ? this.recievedSponsorship.startDate : ''],
      endDate: [this.recievedSponsorship.endDate ? this.recievedSponsorship.endDate : '']
    };

    this.editSponsorshipForm = this.fb.group(formValues);  //populate form with current values
    this.getSponsorshipRequestBySponsorID();
  }

  OpenSponsorship(sponsorships: any) {
    console.log("Edit: ", sponsorships);
    const queryParams: Params = sponsorships;

    this.router.navigate(
      ['/sponsorships/view-single'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  getSponsorshipRequestBySponsorID() {
    this.isLoading = true;
    
    this.sponsorshipsService.getAllSponsorshipsByStatus("NEW").subscribe((data) =>{
      this.isLoading = false;
      console.log("data", data);
      this.sponsorships = data.filter((val: { sponsorId: string; }) => val.sponsorId === this.recievedSponsorship.sponsorId);
      console.log("data filtered", this.sponsorships);
      console.log("data filtered", this.recievedSponsorship.sponsorId);

    }, (error) =>{
      console.log("Error", error);
      this.isLoading = false;
      
    });
  }

  onEditSponsorship() {
    console.log("Edit: ", this.recievedSponsorship);
    const queryParams: Params = this.recievedSponsorship;

    this.router.navigate(
      ['/private-space/edit-sporsorship-request'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }
  
  onSubmitEditForm() {
    this.isLoading = true;
    this.customStylesValidated = true;

    var updatedSponsorshipValues = this.editSponsorshipForm.value;

    updatedSponsorshipValues['sponsorId'] = this.recievedSponsorship.sponsorId;
    updatedSponsorshipValues['propertyId'] = this.recievedSponsorship.propertyId;
    updatedSponsorshipValues['sponsorshipId'] = this.recievedSponsorship.sponsorshipId;

    console.log("Form submitted", updatedSponsorshipValues);

    this.sponsorshipsService.updateSponsorship(updatedSponsorshipValues).subscribe((data) => {
      this.isLoading = false;
      console.log("Results: ", data);

      const queryParams: Params = updatedSponsorshipValues;

      this.router.navigate(
        ['/sponsorship-requests/edit'],
        {
          relativeTo: this.route,
          queryParams: queryParams,
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        });

      alert('You have successfully updated this Sponsorship!');
    }, (error) => {
      this.isLoading = false;
      console.log("Error: ", error);
      alert('The was an error while updating this Sponsorship!');
    });
  }

}
